export const BASE_FLAG_URL = 'https://static.stayforlong.com/web/images/flags/flag-'
export const PLACEHOLDER_URL = `${BASE_FLAG_URL}placeholder.svg`
